import { Box, Typography } from '@mui/material';
import { DocUrls } from "src/types/companies";
import { TableData } from 'src/types/table';

export interface ColumnsTypes {
  field: string;
  headerName: string;
  sortable: boolean;
  width: string;
  maxWidth?: string;
  filterable?: boolean;
  render?: (...args: any) => React.ReactNode;
}

export const companiesColumns: ColumnsTypes[] = [
  {
    field: 'name',
    headerName: 'Name',
    sortable: true,
    width: '25%',
  },
  {
    field: 'email',
    headerName: 'Email',
    sortable: true,
    width: '25%',
  },
  {
    field: 'website',
    headerName: 'Website',
    sortable: true,
    width: '20%',
  },
  //   {
  //    field 'isActive',
  //    headerName 'Status',
  //     sortable: true,
  //     width: '15%',
  //     render: (row: TableData) => (
  //       <CompanyStatus
  //         isActive={Boolean(row.isActive)}
  //         companyId={String(row?.id)}
  //         updateCompanyStatus={updateCompanyStatus}
  //         permissions={permissions}
  //         t={t}
  //       />
  //     ),
  //   },
  //   {
  //    field 'isApprovalRequired',
  //    headerName 'Approval Required',
  //     sortable: true,
  //     width: '15%',
  //     render: (row: TableData) => (
  //       <ApprovalStatus
  //         isApprovalRequired={Boolean(row.isApprovalRequired)}
  //         companyId={String(row?.id)}
  //         updateCompanyApprovalRequired={updateCompanyApprovalRequired}
  //         permissions={permissions}
  //         t={t}
  //       />
  //     ),
  //   },
];

export const projectColumns: ColumnsTypes[] = [
  {
    field: 'name',
    headerName: 'Name',
    sortable: true,
    width: '15%',
  },
  {
    field: 'totalSprints',
    headerName: 'Sprint',
    sortable: true,
    width: '5%',
  },
  {
    field: 'totalCases',
    headerName: 'Total Cases',
    sortable: true,
    width: '5%',
  },
  {
    field: 'pendingCases',
    headerName: 'Pending Cases',
    sortable: true,
    width: '5%',
  },
  {
    field: 'docUrls',
    headerName: 'Link',
    sortable: false,
    width: '35%',
    render: (row: TableData): any => {
      const docUrls: any = row?.docUrls || {};
      const properties = Object.keys(docUrls)?.filter(
        (key) => docUrls[key] && docUrls[key].length > 0,
      );

      return (
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {properties?.map((property) => {
            if (docUrls[property as keyof DocUrls]?.length > 0) {
              return (
                <Typography
                  key={property}
                  sx={{
                    fontSize: 10,
                    fontWeight: 700,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                // onClick={(e) => {
                //   e.stopPropagation();
                //   handleButtonClick(
                //     property,
                //     docUrls[property as keyof DocUrls]!,
                //     e,
                //   );
                // }}
                >
                  {/* {docUrlDisplayNames[property] || property} */}
                  {property}
                </Typography>
              );
            }
            return null;
          })}
        </Box>
      );
    },
  },
  {
    field: 'orgType',
    headerName: 'Org Type',
    sortable: true,
    width: '5%',
  },
];

export const pricebookColumns = [
  { field: 'sku', headerName: 'SKU', sortable: true, width: '10%' },
  { field: 'productName', headerName: 'Product Name', sortable: true, width: '15%' },
  { field: 'catalogue', headerName: 'Catalogue', sortable: true, width: '12%' },
  { field: 'category', headerName: 'Category', sortable: true, width: '12%' },
  { field: 'currency', headerName: 'Currency', sortable: true, width: '8%' },
  { field: 'monthlyMsrp', headerName: 'Monthly MSRP', sortable: true, width: '10%' },
  { field: 'oneYearMsrp', headerName: '1-Year MSRP', sortable: true, width: '10%' },
  { field: 'threeYearMsrp', headerName: '3-Year MSRP', sortable: true, width: '10%' },
  { field: 'description', headerName: 'Description', sortable: false, width: '15%' },
];